
import React, { useState } from 'react';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { useAuth } from '@/context/SupabaseAuthContext';
import SupportTicketList from './SupportTicketList';
import NewTicketDialog from './NewTicketDialog';
import { useTickets } from '@/hooks/useTickets';
import BackToDashboardButton from '@/components/navigation/BackToDashboardButton';
import { createTicket } from '@/utils/supportTicketService';

const SupportTicketPage = () => {
  const { logoutUser } = useAuth();
  const { tickets, isLoading, refreshTickets } = useTickets();
  const [selectedTicketId, setSelectedTicketId] = useState<string | undefined>(undefined);
  
  const handleTicketCreated = async (ticket) => {
    await refreshTickets();
    setSelectedTicketId(ticket.id);
  };
  
  return (
    <DashboardLayout onLogout={logoutUser}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BackToDashboardButton />
        
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Support Center</h1>
            <p className="text-gray-600">Submit and track your support requests</p>
          </div>
          
          <NewTicketDialog onTicketCreated={handleTicketCreated} />
        </div>
        
        <SupportTicketList 
          tickets={tickets} 
          isLoading={isLoading} 
          selectedTicketId={selectedTicketId}
          onSelectTicket={setSelectedTicketId}
        />
      </div>
    </DashboardLayout>
  );
};

export default SupportTicketPage;
